<template>
  <div>
    <div class="ll-box">
    <!-- breadcrumb -->
    <div class="breadcrumb-top">
      <b-breadcrumb class="">
        <b-breadcrumb-item :to="{ name: 'dashboard' }">
          <feather-icon
            icon="HomeIcon"
            size="16"
          />
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          {{ $t('Configuration') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active >
          {{ $t('External Status Code') }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <!-- Add Btn -->
    <div class="d-flex justify-content-end">
      <b-button
        variant="info"
        :to="{ name: 'create-external' }"
        v-permission="[183]"
      >
        <span class="text-nowrap">{{ $t('Create') }}</span>
      </b-button>
    </div>
    </div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend
                is-text
                v-b-toggle.filterS
                class="ll-outline">
                 <svg class="ll-ficon" aria-hidden="true">
                  <use xlink:href="#icon-filter"></use>
                </svg>
              </b-input-group-prepend>
              <b-form-input
                v-model="statusNo"
                class="searchInput"
                placeholder="Please Enter KEC Status No"
              />
              <b-input-group-prepend
                is-text
                class="ll-searchBtn"
                @click="searchById"
                >
                <feather-icon
                  icon="SearchIcon"
                  class="mr-25"
                  size="18"
                />
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Filters sidebar -->
    <b-sidebar id="filterS" title="" right shadow backdrop bg-variant="white">
      <div class="px-3">
        <app-collapse class="ll-collapse">
          <app-collapse-item :title="$t('Customer')">
            <v-select
              :options="customerList"
              label="customer"
              @input="getCustomer"
              placeholder=""
            ></v-select>
          </app-collapse-item>
          <app-collapse-item :title="$t('Is Active')">
            <v-select
              id="isActive"
              :options="statusList"
              label="status"
              placeholder=""
              @input="selStatus"
            ></v-select>
          </app-collapse-item>
        </app-collapse>
        <div class="ll-btn">
          <b-button
            variant="secondary"
            class="mr-1"
            @click="onClear"
          >
            {{ $t('Clear') }}
          </b-button>
          <b-button variant="info"
            v-b-toggle.filterS
            @click="filterSearch">
            {{ $t('Search') }}
          </b-button>
        </div>
      </div>
    </b-sidebar>

    <!-- table -->
    <b-table
      ref="refUserListTable"
      class="position-relative ll-table"
      :items="rows"
      :fields="columns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      :striped="true"
      :hover="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @sort-changed="onSortChange"
      v-permission="[182]"
      :sticky-header="true"
      :busy="isBusy"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(isEnabled)="row">
        <b-badge
          :variant="row.value ? 'light-info' : 'light-secondary'"
          class="ll-badge">
          <span>{{ row.value ? 'Active' : 'Inactive' }}</span>
        </b-badge>
      </template>
      <!-- Column: Actions -->
      <template #cell(action)="data">
        <b-button
          variant="flat-secondary"
          class="btn-icon rounded-circle ll-act"
          v-b-toggle.modifyS
          v-if="false"
        >
          <feather-icon icon="EditIcon" @click="onEdit(data.item.id, data.item.internalStatusNo)"/>
        </b-button>
        <feather-icon
          icon="EditIcon"
          @click="$router.push({ name: 'external-detail', params: { id: data.item.id }})"
          v-permission="[184]"
        />
        <b-button
          variant="flat-secondary"
          class="btn-icon rounded-circle ll-act"
          v-permission="[184]"
        >
          <feather-icon icon="TrashIcon" class="mr-50" @click="onDel(data.item.id)"/>
        </b-button>
      </template>
    </b-table>
    <div class="d-flex justify-content-between flex-wrap ll-p">
      <div class="d-flex align-items-center mb-0 mr-1">
        <span class="text-nowrap ">
          Showing 1 to
        </span>
        <b-form-select
          v-model="size"
          :options="pageOptions"
          class="mx-1"
          @input="handlePageChange"
        />
        <span class="text-nowrap"> of {{ totalSize }} entries </span>
      </div>
      <div>
        <b-pagination
          v-model="page"
          :total-rows="totalSize"
          :per-page="size"
          first-number
          last-number
          class="mb-0 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @change="handleChangePage"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </div>

    <!-- Edit sidebar -->
    <b-sidebar id="modifyS" title="Edit Status Code" right shadow backdrop>
      <div class="px-3">
        <b-form-group
          class="g-label"
          label="KEC Status No"
          label-for="sType"
        >
          <b-form-input
            id="sType"
            v-model="editInfo.internalStatusNo"
          />
        </b-form-group>
        <b-form-group
          class="g-label"
          label="originStatusCode"
          label-for="statusNo"
          v-if="false"
        >
          <b-form-input
            id="statusNo"
            v-model="editInfo.originStatusCode"
          />
        </b-form-group>
        <b-form-group
          class="g-label"
          label="External Code 1"
          label-for="statusNo"
        >
          <b-form-input
            v-model="editInfo.externalStatusCode"
          />
        </b-form-group>
        <b-form-group
          class="g-label"
          label="External Code 2"
          label-for="statusNo"
        >
          <b-form-input
            v-model="editInfo.externalStatusCode2"
          />
        </b-form-group>
        <b-form-group
          class="g-label"
          label="External Message"
          label-for="statusDes"
        >
          <b-form-input
            id="statusDes"
            v-model="editInfo.originStatusMessage"
          />
        </b-form-group>
        <b-form-group
          class="g-label"
          label="Org ID"
          label-for="tag"
        >
          <b-form-input
            id="tag"
            v-model="editInfo.orgID"
          />
        </b-form-group>
        <!-- <b-form-group
          class="g-label"
          label="Tag Color"
        >
          <colorPicker v-model="color" @change="headleChangeColor"/>
        </b-form-group> -->
        <b-form-group
          class="g-label"
          label="Is Active"
        >
          <div class="demo-inline-spacing">
            <b-form-radio
              v-model="editInfo.isEnabled"
              name="some-radios"
              value="true"
            >
              Active
            </b-form-radio>
            <b-form-radio
              v-model="editInfo.isEnabled"
              name="some-radios"
              value="false"
            >
              Inactive
            </b-form-radio>
          </div>
        </b-form-group>
        <div class="ll-btn">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="onClear1"
        >
          Clear
        </b-button>
        <b-button variant="info"
          @click="editSubmit"
          v-b-toggle.modifyS>
          Save
        </b-button>
      </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BButton,
  // BTooltip,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BSidebar,
  VBToggle,
  BTable,
  BInputGroupPrepend,
  BInputGroup,
  BBreadcrumb,
  BBreadcrumbItem,
  BBadge, BFormRadio, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import permission from '@core/directives/permission/index.js'

export default {
  components: {
    BPagination,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BButton,
    // BTooltip,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BSidebar,
    vSelect,
    BTable,
    BInputGroupPrepend,
    BInputGroup,
    BBreadcrumb,
    BBreadcrumbItem,
    BBadge,
    BFormRadio,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AppCollapse,
    AppCollapseItem,
    BSpinner,
  },
  directives: {
    'b-toggle': VBToggle,
    permission,
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      pageOptions: [50, 100, 200],
      page: null, // 当前页码
      size: 15, // 每页个数
      totalSize: null, // 总个数
      totalPage: null, // 总页数
      columns: [
        { key: 'orgID', label: this.$t('Org ID'), sortable: true },
        { key: 'customerName', label: this.$t('Customer Name'), sortable: true },
        { key: 'internalStatusNo', label: this.$t('KEC Status No'), sortable: true },
        { key: 'externalStatusCode', label: this.$t('External Code')+' 1', sortable: true },
        { key: 'externalStatusCode2', label: this.$t('External Code')+' 2', sortable: true },
        { key: 'originStatusMessage', label: this.$t('External Message'), sortable: true },
        // { key: 'roles', label: 'Description', sortable: true },
        { key: 'isEnabled', label: this.$t('Status'), sortable: true },
        { key: 'action', label: this.$t('Action'), class: 'll-action' },
      ],
      rows: [],
      searchTerm: '',
      customerList: [],
      statusTypeList: [],
      statusList: [
        { value: null, status: 'all' },
        { value: true, status: 'active' },
        { value: false, status: 'inactive' },
      ],
      formTime: '',
      toTime: '',
      condition: {
        page: '1',
        size: '50',
        orderMole: 0,
        orderBy: 'id',
        statusNo: null,
        statusType: null,
        isEnabled: null,
        orgID: '',
      },
      condition1: {
        page: '1',
        size: '15',
        orderMole: 0,
        orderBy: 'id',
        statusNo: [],
        statusType: [],
        isEnabled: null,
        orgID: '',
      },
      statusNo: '',
      editInfo: {
        id: '',
        internalStatusNo: '',
        isEnabled: null,
        // originStatusCode: '',
        originStatusMessage: '',
        orgID: '',
        externalStatusCode: '',
        externalStatusCode2: '',
      },
      isBusy: true,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getList()
    this.queryCustomer()
    // this.queryStatusType()
  },
  methods: {
    // 首次查询
    getList() {
      this.$http.post('/csCansExt/search', this.condition).then(res => {
        // console.log('ss', res.data.data)
        const info = res.data.data
        this.rows = info.content
        this.page = info.page
        this.size = info.size
        this.totalSize = info.totalSize
        this.totalPage = info.totalPage
        this.isBusy = false
      }).catch(error => console.log(error))
    },
    // 点击单行
    onRowClick() {
      // console.log('onRowClick')
    },
    onSearch() {
      // console.log('onSearch')
    },
    onClear() {
      this.condition = {}
    },
    // 条件过滤搜索
    filterSearch() {
      this.getList()
    },
    // 排序规则
    onSortChange(params) {
      const orderBy = params.sortBy
      const orderMole = params.sortDesc ? 0 : 1
      this.condition.orderBy = orderBy
      this.condition.orderMole = orderMole
      this.getList()
    },
    // 根据Id查询
    searchById() {
      if (this.statusNo.trim() !== '') {
        this.condition.statusNo = this.statusNo.trim().split(/[(\r\n)\r\n]+/)
        this.getList()
      } else {
        this.condition.statusNo = []
        this.getList()
      }
    },
    // 获取客户名
    getCustomer(c) {
      this.condition.orgID = c.providerCode
    },
    // 获取statusType
    getStatusType(t) {
      this.condition.statusType = t.statusType.split()
    },
    selStatus(s) {
      this.condition.isEnabled = s.value
    },
    // 获取客户名列表
    queryCustomer() {
      this.$http.get('csCansExt/getCustomerList').then(res => {
        this.customerList = res.data.data
      })
    },
    // 获取statusType列表
    queryStatusType() {
      this.$http.get('csCansExt/getStatusTypeList').then(res => {
        if (res.data.code === '200') {
          if (res.data.data[0] !== null) {
            this.statusTypeList = res.data.data
          } else {
            this.statusTypeList = []
          }
        }
      })
    },
    // 点击编辑按钮
    onEdit(id, code) {
      this.editInfo.id = id
      this.condition1.statusNo = code.split(/[(\r\n)\r\n]+/)
      this.$http.post('/csCansExt/search', this.condition1).then(res => {
        const info = res.data.data.content[0]
        this.editInfo.isEnabled = info.isEnabled
        this.editInfo.internalStatusNo = info.internalStatusNo
        this.editInfo.originStatusMessage = info.originStatusMessage
        this.editInfo.orgID = info.orgID
        this.editInfo.externalStatusCode = info.externalStatusCode
        this.editInfo.externalStatusCode2 = info.externalStatusCode2
      }).catch(error => console.log(error))
    },
    // 删除
    onDel(id) {
      this.box = ''
      this.$bvModal
      .msgBoxConfirm('Please confirm that you want to delete .', {
        title: 'Handle',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      })
      .then(value => {
        if (value) {
          this.box = value
          this.onDel1(id)
        }
      })
    },
    onDel1(id) {
      this.$http.delete(`/csCansExt/delete/${id}`).then(res=>{
        if (res.data.code === '200') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Delete Success',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.getList()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
      })
    },
    // 编辑提交
    editSubmit() {
      this.$http.put('csCansExt/update', this.editInfo).then(res => {
        if (res.data.code === '200') {
          this.condition.statusNo = null
          this.getList()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Edit Success',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.getList()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
      })
    },
    onClear1() {
      this.editInfo = {}
    },
    handleChangePage(page) {
      this.condition.page = page
      this.getList()
    },
    handlePageChange(active) {
      this.condition.size = active
      this.getList()
    },
  },
}
</script>
<style scoped>
/* .ll-p{
  position: fixed;
  bottom: 40px;
  right: 10px;
} */
.ll-btn{
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-right: 6rem;
  width: 100%;
}
.ll-btnS{
  margin-right: 20px;
}
.ll-colBox{
  margin: auto;
}
.ll-outline{
  outline: none;
}
.ll-searchBtn div{
  background-color: #ff9f43;
  color: #fff;
  width: 60px;
  display: flex;
  justify-content: center;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.ll-box{
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 10px;
}
.ll-act{
  height: 15px;
  width: 15px;
  margin-left: 10px;
}
.btn .feather{
  position: relative;
  top: -8px;
  left: -5px;
}
</style>
<style>
[dir] .vgt-table.bordered th{
  padding: 10px;
  font-size: 12px;
}
table.vgt-table{
  font-size: 12px;
}
[dir=ltr] .b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-left: unset;
  margin-right: unset;
  font-size: 20px;
}
[dir=ltr] .b-sidebar.b-sidebar-right{
  width: 25%;
}
[dir] .page-item.active{
  height: 27px;
}
.table thead th, .table tfoot th {
  text-transform: capitalize;
}
</style>
